/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { sprintf } from '../vendor/sprintf.js';
import { arr_inArray, htmlspecialchars, is_valid_email, is_valid_email_list, mj_cloned_object, str_trim, copyToClipboard } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, getPreferedMaxDialogHeight } from './dialog-util.js';
import { error_box, big_confirm_box } from './page-modal.js';
import { showInfoToastWithLink, showWarningToast, showInfoToast, showErrorToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';
import { postToBackend } from './fetch-util.js';

import { MPlugins } from './plugins.js';
import { MDTimezones } from './timezone.js';
import { MDLocale } from './locale-impl.js';

import { MDObject } from './object-data.js';
import { convertToSelect2WithDefaultFit } from './select2.js';
import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';


export let MVSend = function($,mj) {

	var saa_archive_id = null;

	var m_sender = {
		login: '',
		'short-display-name': '',
		userdata: {},
	};

	function clear_file_list( detach ) {
		$('#ms-c-list').hide();
		var ms_list = $('#ms-list');
		if( detach ) ms_list = ms_list.detach();
		ms_list.children('[id^=ms-file-],[id^=ms-lb-]').remove();
		return ms_list;
	}


	function _reset_ms() {
		$('#ms-form').dialog('destroy');

		// elements for "send as lightbox"
		$('#ms-c-context').empty();
		if( $('#ms-rcpt').data('select2') ) $('#ms-rcpt').select2('destroy');

		$('#ms-c-user-data,#ms-c-guest-data').hide()
			.find('input[type=text]').val('');

		$('#ms-c-rcpt-list').hide();
		$('#ms-rcpt-list .ms-rcpt-block').remove();

		$('#ms-c-list').data('had_rcpt_perms',true);
		clear_file_list();

		$('#ms-all-perms-box').hide();
		$('#ms-all-perms-list').empty();
		$('#ms-c-mail-data').hide()
			.find('input[type=text],textarea').val('');

		$('#ms_lb_title,#ms_mail_subject,#ms_notifications_rcpts')
			.off('.mjMVSend');

		$('#ms-c-notifications').hide();
		$('#ms-c-plugin-data').hide();
		$('#ms_notifications_rcpts').val('');
		$('#ms-c-actions').hide();
		$('#ms-send-button .label').text(mjt('ms-send-button'));

		// elements for "send as attachment"
		saa_archive_id = null;
		$('#ms-saa-format-list').empty();
		$('#ms-sal-format-list').empty();
		$('#ms-saa-list').find('> div.ms-saa-real-file-item').remove();
		$('#ms-sal-list').find('> div.ms-sal-real-file-item').remove();
		$('#ms-saa-c-mail')
			.find('input[type=text]').val('').end()
			.find('textarea').val('');
		// reset notifications rcpts...
		$('#ms-saa-c-notifications').hide();
		$('#ms_saa_notifications_rcpts').val('');
	}

	function _reset_msslb() {
		$('#msslb-form').dialog('destroy');
		$('#msslb-list').children('[id^=msslb-item-]').remove();
	}


	function _setup_dialog_tabs( media_ids, lb_title, mode, pluginContext ) {
		var tabs = [ {
			id:		'lightbox',
			html:	'<span id="ms-send-as-lightbox-link" class="link" tabindex="0" role="button">'+mjt('ms-title-send-as-lightbox')+'</span>',
		} ];
		if( mj.send.send_as_attachment_enabled && !pluginContext ) {
			// NOTE: MediaSendView plugins currently only exist for send-as-lightbox only.
			// hide send-as-attachment now to avoid confusion..
			tabs.push( {
				id:		'attachment',
				html:	'<span id="ms-send-as-attachment-link" class="link" tabindex="0" role="button">'+mjt('ms-title-send-as-attachment')+'</span>',
			} );
		}
		if(!pluginContext) {
			tabs.push( {
				id:		'link',
				html:	'<span id="ms-send-as-link-link" class="link" tabindex="0" role="button">'+mjt('ms-title-send-as-link')+'</span>',
			} );
		}
		$('#ms-form').closest('.ui-dialog').find('> .ui-dialog-titlebar > .ui-dialog-title')
			.mjDialogTabs( { tabs:tabs } )
			.mjDialogTabs( 'activate', mode )
			.find('#ms-send-as-lightbox-link').click( function() {
				openMediaIDs(media_ids,lb_title,'lightbox',pluginContext);
			} ).end()
			.find('#ms-send-as-attachment-link').click( function() {
				openMediaIDs(media_ids,lb_title,'attachment',pluginContext);
			} ).end()
			.find('#ms-send-as-link-link').click( function() {
				openMediaIDs(media_ids,lb_title,'link',pluginContext);
			} ).end();
	}


	function _get_avl_item_perms_in_dlfs( download_formats, media_classes ) {
		var avl_perms = [ {action:'2',names:[]}, {action:'3',names:[]} ];
		for( var i in download_formats ) {
			if( !download_formats.hasOwnProperty(i) ) continue;
			var dlf = download_formats[i];
			if( arr_inArray(dlf.media_class,media_classes) != -1 ) {
				var found = false;
				for( var i2=0; i2<avl_perms.length; ++i2 ) {
					if( avl_perms[i2].action==dlf.acl_action ) {
						avl_perms[i2].names.push(dlf.name);
						avl_perms[i2].mcs.push(dlf.media_class);
						found = true;
						break;
					}
				}
				if( !found ) avl_perms.push( {action:dlf.acl_action,names:[dlf.name],mcs:[dlf.media_class]} );
			}
		}
		return avl_perms;
	}


	function _get_file_item_perms_html( media_id, media_class, download_formats, sender_perms, rcpt_perms, watermarks_enabled ) {
		var avl_perms = _get_avl_item_perms_in_dlfs(download_formats,[media_class]);
		var html = '';
		for( var i=0; i<avl_perms.length; ++i ) {
			var ap = avl_perms[i],
				name = '',
				checked = true,
				disabled = false,
				hint = false;
			switch( parseInt(ap.action,10) ) {
			case 2:
				name = mjt('acl-action-view-lowres');
				if( !watermarks_enabled ) continue;
				break;
			case 3:
				name = watermarks_enabled ? mjt('acl-action-view-highres') : mjt('acl-action-view-allres');
				break;
			case 4:
				name = mjt('acl-action-download');
				break;
			default:
				name = sprintf(mjt('acl-action-custom-download-format'),0,htmlspecialchars(ap.names[0]));
				for( var i2=1; i2<ap.names.length; ++i2 ) {
					name += ' '+sprintf(mjt('acl-action-custom-download-format-append'),0,htmlspecialchars(ap.names[i2]));
				}
			}
			if( !sender_perms[ap.action] || !sender_perms[ap.action][media_id] ) {
				// sender does not have permission, so can not transfer it
				disabled = true;
				checked = false;
				hint = mjt('ms-hint-sender-does-not-have-perm');
			} else if( rcpt_perms===null ) {
				// multiple rcpts -> assume each rcpt may or may not have that permission
				disabled = false;
				checked = true;
				hint = mjt('ms-hint-will-try-to-transfer-perm-to-all-rcpts');
			} else if( rcpt_perms[ap.action] && rcpt_perms[ap.action][media_id] ) {
				// rcpt already has the permission, so we do not have to transfer it
				disabled = true;
				checked = true;
				hint = mjt('ms-hint-rcpt-already-has-perm');
			}
			html += '<input id="ms_perms_'+media_id+'_'+ap.action+'" type="checkbox" name="acl_actions['+media_id+'][]" class="ms-perm" title="'+(hint?(name+' \n'+hint):name)+'" value="'+ap.action+'" '+(checked?' checked="checked"':'')+(disabled?' disabled="disabled"':'')+'/>'
					+'<label for="ms_perms_'+media_id+'_'+ap.action+'"'+(hint?' title="'+hint+'"':'')+(disabled?' class="disabled"':'')+'> '+name+'</label>'
					+'<br />';
		}
		return html;
	}

	function _get_list_item_perms_html( list_id, list_media_ids, meta, download_formats, sender_perms, rcpt_perms, watermarks_enabled ) {
		var media_classes = [];
		var i, i2, media_id, media_class;
		for( i=0; i<list_media_ids.length; ++i ) {
			var mid = list_media_ids[i];
			media_class = meta && meta[mid] && meta[mid][-1] ? meta[mid][-1][0] : 0;
			if( arr_inArray(media_class,media_classes) == -1 ) media_classes.push(media_class);
		}
		var avl_perms = _get_avl_item_perms_in_dlfs(download_formats,media_classes);
		var html = '';
		for( i=0; i<avl_perms.length; ++i ) {
			var ap = avl_perms[i];
			var name = '';
			var checked = true;
			var disabled = false;
			var hint = false;
			var filter_by_mc = false;
			switch( parseInt(ap.action,10) ) {
			case 2:
				name = mjt('acl-action-view-lowres');
				if( !watermarks_enabled ) continue;
				break;
			case 3:
				name = watermarks_enabled ? mjt('acl-action-view-highres') : mjt('acl-action-view-allres');
				break;
			case 4:
				name = mjt('acl-action-download');
				break;
			default:
				filter_by_mc = true;
				name = sprintf(mjt('acl-action-custom-download-format'),0,htmlspecialchars(ap.names[0]));
				for( i2=1; i2<ap.names.length; ++i2 ) name += ' '+sprintf(mjt('acl-action-custom-download-format-append'),0,htmlspecialchars(ap.names[i2]));
			}
			var sender_has_some_perms=false;
			var rcpt_has_all_perms=true;
			if( filter_by_mc ) {
				for( i2=0; i2<list_media_ids.length; ++i2 ) {
					media_id = list_media_ids[i2];
					media_class = meta && meta[media_id] && meta[media_id][-1] ? meta[media_id][-1][0] : 0;
					if( arr_inArray(media_class,ap.mcs) != -1 ) {
						// sender has permission on at least one item in list
						if( sender_perms[ap.action] && sender_perms[ap.action][media_id] ) sender_has_some_perms = true;
						// rcpt does not have permission on at least one item in list
						if( rcpt_perms!=null && !(rcpt_perms[ap.action] && rcpt_perms[ap.action][media_id]) ) rcpt_has_all_perms = false;
					}
				}
			} else {
				for( i2=0; i2<list_media_ids.length; ++i2 ) {
					media_id = list_media_ids[i2];
					// sender has permission on at least one item in list
					if( sender_perms[ap.action] && sender_perms[ap.action][media_id] ) sender_has_some_perms = true;
					// rcpt does not have permission on at least one item in list
					if( rcpt_perms!=null && !(rcpt_perms[ap.action] && rcpt_perms[ap.action][media_id]) ) rcpt_has_all_perms = false;
				}
			}
			if( !sender_has_some_perms ) {
				// sender does not have permission on any item, so can not transfer it
				disabled = true;
				checked = false;
				hint = mjt('ms-hint-sender-does-not-have-perm');
			} else if( rcpt_perms===null ) {
				// multiple rcpts -> assume each rcpt may or may not have that permission
				disabled = false;
				checked = true;
				hint = mjt('ms-hint-will-try-to-transfer-perm-to-all-rcpts');
			} else if( rcpt_has_all_perms ) {
				// rcpt already has the permission on all items, so we do not have to transfer it
				disabled = true;
				checked = true;
				hint = mjt('ms-hint-rcpt-already-has-perm');
			}
			html += '<input id="ms_perms_'+list_id+'_'+ap.action+'" type="checkbox" name="acl_actions['+list_id+'][]" title="'+(hint?(name+' \n'+hint):name)+'" value="'+ap.action+'" '+(checked?' checked="checked"':'')+(disabled?' disabled="disabled"':'')+'/>'
					+'<label for="ms_perms_'+list_id+'_'+ap.action+'"'+(hint?' title="'+hint+'"':'')+(disabled?' class="disabled"':'')+'> '+name+'</label>'
					+'<br />';
		}
		return html;
	}



	function _get_saved_rcpts_count() {
		return $('#ms-rcpt-list .ms-rcpt-block').length;
	}

	function _get_saved_rcpts_data() {
		var all_rcpts_data = [];
		$('#ms-rcpt-list .ms-rcpt-block').each( function() {
			all_rcpts_data.push(
				[
					$(this).data('user_id'),
					$(this).data('expires'),
				]
			);
		} );
		return all_rcpts_data;
	}

	function _get_unq_avl_perms( ms_list ) {
		var avl_perms = [];
		var got = {};
		ms_list.find('> .ms-file-item > .ms-item-perms > input.ms-perm:enabled').each( function() {
			var self = $(this);
			var action = parseInt(self.attr('value'),10);
			if( !got.hasOwnProperty(action) ) {
				avl_perms.push( [action,self.attr('title')] );
				got[action] = true;
			}
		} );
		return avl_perms;
	}

	function _check_file_item_perms( ms_list, action, check ) {
		ms_list.find('> .ms-file-item > .ms-item-perms > input.ms-perm:enabled').each( function() {
			var self = $(this);
			var ia = parseInt(self.attr('value'),10);
			if( ia==action ) self.prop('checked',!!check);
		} );
	}

	function _prep_mail_text( tmpl_str, rcpt ) {
		var repl = {
			'username':				rcpt.login,
			'display-name':			rcpt['short-display-name'],
			'first-name':			rcpt.userdata['first-name'],
			'last-name':			rcpt.userdata['last-name'],
			'email-address':		rcpt.userdata['email'],
			'valid-until-dt':		rcpt.expires,

			'sender-username':		m_sender.login,
			'sender-display-name':	m_sender['short-display-name'],
			'sender-first-name':	m_sender.userdata['first-name'],
			'sender-last-name':		m_sender.userdata['last-name'],
			'sender-email-address':	m_sender.userdata['email'],
		};
		for( var k in repl ) {
			if( !repl.hasOwnProperty(k) ) continue;
			tmpl_str = tmpl_str.replace( new RegExp('%%'+k+'%%','g'), repl[k] );
		}
		return tmpl_str;
	}



	function build_userhash( userlist ) {
		var userhash = {};
		for( var idx in userlist ) {
			if( !userlist.hasOwnProperty(idx) ) continue;
			var user = userlist[idx];
			var txt = user['display-name'];
			if( user.expires != '' ) txt += ' - '+mjt('ms-valid-until')+' ' + MDLocale.fmt_datetime( MDTimezones.datetime_utc2local(user.expires) );
			user['ext-display-name'] = txt;
			userhash[user.user_id] = user;
		}
		return userhash;
	}


	function get_mail_subject_text( tmpl_str, rcpt, pluginContext ) {

		if( pluginContext ) {
			MPlugins.callOnAllPluginsOfType('MediaSendView','getMailSubjectText',true,m_sender,rcpt,pluginContext);
			if( pluginContext.hasOwnProperty('subject') ) {
				return pluginContext.subject;
			}
		}

		if( !tmpl_str ) return mjt('ms-mail-subject-default').replace('%1',m_sender['short-display-name']);
		var rcpt_email = null;
		var expires_hours_offs = null;
		if( rcpt===null ) {
			// rcpt is a guest
			rcpt_email = str_trim($('#ms_guest_email').val());
			var first_name = str_trim($('#ms_guest_first_name').val());
			var last_name = str_trim($('#ms_guest_last_name').val());
			var short_display_name = str_trim(first_name+' '+last_name);
			if( short_display_name==='' ) short_display_name = rcpt_email;
			rcpt = {
				'short-display-name': short_display_name,
				login: rcpt_email,
				userdata: {
					'first-name': first_name,
					'last-name': last_name,
					email: rcpt_email,
				},
				expires: '',
			};
			expires_hours_offs = $('#ms_guest_expires').val();
		} else {
			// rcpt is an actual user
			rcpt = mj_cloned_object(rcpt);
			rcpt_email = rcpt.userdata.hasOwnProperty('email') ? str_trim(rcpt.userdata.email) : 'unknown';
			if( rcpt.expires != '' ) {
				// add eventual extension of expiry ...
				expires_hours_offs = $('#ms_user_expires').val();
			}
		}
		if( rcpt_email!==null ) {
			// update rcpts email address info
			rcpt.userdata.email = rcpt_email;
		}
		if( expires_hours_offs!==null ) {
			// compute actual expiry timestamp of guest or user ..
			var dt_obj = new Date(Date.now());
			dt_obj.setTime( dt_obj.getTime() + (expires_hours_offs*60*60*1000) );
			rcpt.expires = MDTimezones.datetime_local2utc( MDTimezones.mj_date_object_to_datetime_string(dt_obj) );
		}
		return _prep_mail_text(tmpl_str,rcpt);
	}

	function update_mail_subject( tmpl_str, rcpt, pluginContext ) {
		$('#ms_mail_subject').val(get_mail_subject_text(tmpl_str,rcpt,pluginContext));
	}



	function build_rcpt_select( ms_rcpt, userlist, send_to_guest_enabled, on_change_rcpt, pluginContext ) {
		var saved_rcpts_data = _get_saved_rcpts_data();

		var rcpt_data = [ {
			id: '',
			text: saved_rcpts_data.length > 0 ? mjt('ms-rcpt-select-another') : mjt('ms-rcpt-select'),
		} ];

		var hint_html = '';
		if( send_to_guest_enabled ) {
			rcpt_data.push( {
				id: 'guest',
				text: mjt('ms-rcpt-guest'),
				// NOTE: send-to-multiple-rcpts and send-to-guest is currently not compatible,
				// - so: when at least one rcpt was saved to list, then guest is disabled,
				// - also: send-to-guest is available only when no other rcpt is added to list
				disabled: saved_rcpts_data.length > 0,
			} );
			hint_html = mjt('ms-hint-rcpt-1');
		} else {
			hint_html = saved_rcpts_data.length > 0 ? mjt('ms-hint-rcpt-2-another') : mjt('ms-hint-rcpt-2');
		}
		hint_html += ' ' + mjt('ms-hint-rcpt-all-sfx');
		$('#ms-c-rcpt .hint').html(hint_html);

		// add rcpts to selection (in pre-sorted order),
		for( var idx in userlist ) {
			if( !userlist.hasOwnProperty(idx) ) continue;
			var user = userlist[idx];
			if( !user.active ) continue; // hide inactive users
			var option_text = user['ext-display-name'] || 'unknown';
			var disabled = false;
			// disable when rcpt has no email address configured
			if( !user.userdata || !str_trim(user.userdata.email) ) {
				disabled = true;
				option_text += ' '+mjt('ms-rcpt-email-unknown');
			}
			// disable when user is already selected as rcpt ..
			for( var sri=0; sri<saved_rcpts_data.length; ++sri ) {
				if( user.user_id == saved_rcpts_data[sri][0] ) {
					disabled = true;
					option_text += ' '+mjt('ms-rcpt-is-already-selected');
					break;
				}
			}
			rcpt_data.push( {
				id: user.user_id,
				text: option_text,
				disabled: disabled,
			} );
		}

		var localPluginContext = {};
		MPlugins.callOnAllPluginsOfType('MediaSendView','postProcessAvailableRcptsList',true,m_sender,rcpt_data,localPluginContext);
		if( localPluginContext.hasOwnProperty('rcpt_list') ) {
			rcpt_data = localPluginContext.rcpt_list;
		}

		// destroy & re-build select2 ..
		if( ms_rcpt.data('select2') ) ms_rcpt.select2('destroy');

		ms_rcpt
			.off()
			.empty()
			.on('change',function(evt) {
				var self = this;
				setTimeout( function() {
					on_change_rcpt.call(self,evt);
				}, 350 );
			} );

		convertToSelect2WithDefaultFit(
			ms_rcpt,
			false,
			{
				ajax: {},
				dataAdapter: $.fn.select2.amd.require('mjSelect2CustomPaginationDataAdapter'),
				pageSize: 100,
				data: rcpt_data,

				closeOnSelect: false,
				templateResult: function _select2_templateResult( item, li ) {
					var term = window._mj_cur_select2_query.term || '';
					if( term==='' ) {
						// optimized non-search case..
						return $('<span></span>').text(item.text);
					}
					return window._mj_select2_markMatch(item.text,term,item.class||'');
				},
			}
		);

		ms_rcpt
			.select2('on','select',function(evt) {
				var self = this;
				// Don't close if the control key is being held
				if( evt.originalEvent && evt.originalEvent.ctrlKey ) return;

				// instead of closing directly, we animate the dropDown, ...
				var s2_dropdown = self.$dropdown.find('.select2-dropdown');
				s2_dropdown.slideUp('fast',function() {
					// .., and then trigger close
					self.trigger('close');
					s2_dropdown.show(); // restore css display attr
				} );
			} );

	}



	function open_SendAsLightbox( j, all_media_ids, list_callback, lb_title_callback, extra_postdata_callback, dlg_open_callback, pluginContext ) {

		// and prepare hashmap uid=>userobj
		var userhash = build_userhash(j.userlist);
		m_sender = userhash[j.self_uid];

		if( pluginContext ) {
			MPlugins.callOnAllPluginsOfType('MediaSendView','handleSendInfoResponse',true,j,pluginContext);
		}

		function update_form_validation_state( show_error_box, evt, on_validation_success ) {
			//console.log({fn:'update_form_validation_state',show_error_box,evt});

			var form = $('#ms-form-send-as-lightbox');
			var form_fields_0 = form.find(':input').not(':button');

			// clear all error states
			form_fields_0.filter('.error')
				.not('.validation-pending,.sticky-error')
				.removeClass('error')
				.next('.error').remove();

			// only validate inputs that are visible and enabled
			var form_fields_1 = form_fields_0.filter('[name]').filter(':visible').not(':disabled');

			var _clear_error_state = function( $input_elem ) {
				$input_elem.filter('.error')
					.removeClass('error')
					.next('.error').remove();
			};

			var _try_form_validation_succeed = function() {
				if( form_fields_1.filter('.validation-pending').length !== 0 ) {
					// pending states are not resolved yet ..
					$('#ms-send-button').prop('disabled',true);
				} else {
					// all pending states resolved -> succeed or fail now
					var fields_errors_count = form_fields_1.filter('.error').length;
					// enable/disable send-button ..
					var enable_send_button = fields_errors_count===0 && !$('#ms-c-user-data').is(':visible');
					$('#ms-send-button').prop('disabled',!enable_send_button);
					if( fields_errors_count===0 && on_validation_success ) {
						// succeed ...
						on_validation_success(form_fields_1);
					}
				}
			};

			var _render_validation_error = function( $input_elem_or_selector, error_string ) {
				var $input_elem = form_fields_1.filter($input_elem_or_selector);
				$input_elem.addClass('error');
				var $hint_elem = $input_elem.next('.error').first();
				if( $hint_elem.length===0 ) $hint_elem = $('<span class="error"></span>').insertAfter($input_elem);
				return $hint_elem.text(error_string);
			};

			var _resolve_validation_pending_state = function( $input_elem ) {
				if( $input_elem.hasClass('validation-pending') ) {
					$input_elem.removeClass('validation-pending');
					_try_form_validation_succeed();
				}
			};

			// validate inputs
			var error_list = [];
			var selected_rcpt_user_id = form_fields_1.filter('[name=rcpt]').val();
			if( selected_rcpt_user_id==='guest' ) {
				// guest
				var is_input_event_from_guest_email = evt && evt.type=='input' && evt.target && evt.target.name=='guest-email';
				if( is_input_event_from_guest_email ) {
					var $guest_email_input_elem = form_fields_1.filter('[name=guest-email]');
					if( !$guest_email_input_elem.hasClass('validation-pending') ) {
						$guest_email_input_elem.addClass('sticky-error');
						var guest_email = str_trim($guest_email_input_elem.val());
						if( guest_email==='' ) {
							error_list.push(['[name=guest-email]',mjt('ms-err-email-required')]);
						} else if( !is_valid_email(guest_email) ) {
							error_list.push(['[name=guest-email]',mjt('ms-err-invalid-email')]);
						} else {
							_clear_error_state($guest_email_input_elem);
							check_guest_email($guest_email_input_elem,_render_validation_error,_resolve_validation_pending_state);
						}
					}
				}
				if( str_trim(form_fields_1.filter('[name=guest-first-name]').val())=='' ) error_list.push(['[name=guest-first-name]',mjt('ms-err-first-name')]);
				if( str_trim(form_fields_1.filter('[name=guest-last-name]').val())=='' ) error_list.push(['[name=guest-last-name]',mjt('ms-err-last-name')]);

			} else {
				// user
				var has_saved_rcpts = _get_saved_rcpts_count() > 0;
				if( !has_saved_rcpts ) error_list.push([null,mjt('ms-err-no-rcpts-selected')]);

			}
			if( lb_title_callback && str_trim(form_fields_1.filter('[name=lb-title]').val())=='' ) error_list.push(['[name=lb-title]',mjt('ms-err-lb-title')]);
			if( str_trim(form_fields_1.filter('[name=mail-subject]').val())=='' ) error_list.push(['[name=mail-subject]',mjt('ms-err-mail-subject')]);
			if( mj.send.notify_rcpts_editable ) {
				var xvtmp = str_trim(form_fields_1.filter('[name=notifications-rcpts]').val());
				if( xvtmp!='' && !is_valid_email_list(xvtmp) ) error_list.push(['[name=notifications-rcpts]',mjt('ms-err-invalid-notifications-rcpts-email')]);
			}

			if( error_list.length ) {
				// render immediate validation errors ...
				var err_strings = [];
				for( var i=0; i<error_list.length; ++i ) {
					if( error_list[i][0]!=null ) _render_validation_error(error_list[i][0],error_list[i][1]);
					err_strings.push(error_list[i][1]);
				}
				if( show_error_box ) error_box(mjt('ms-err-title'),mjt('ms-err-text'),err_strings);
			}

			_try_form_validation_succeed();
		}


		function check_guest_email( $input_elem, _render_validation_error, _resolve_validation_pending_state ) {
			$input_elem.addClass('validation-pending');
			var guest_email = str_trim($input_elem.val());
			$.postJSON2(
				'json/media/send-find_users_by_email',
				'email='+encodeURIComponent(guest_email),
				function _on_success(j2) {
					if( !j2 || !j2.user_ids || j2.user_ids.length===0 ) return;
					var $hint_elem;
					for( var i=0; i<j2.user_ids.length; ++i ) {
						if( i===0 ) {
							$hint_elem = _render_validation_error( $input_elem, j2.user_ids.length===1 ? mjt('ms-guest2user-hint-email-of-existing-user-1') : mjt('ms-guest2user-hint-email-of-existing-user') );
						}
						var other_user_id = j2.user_ids[i];
						var other_user = userhash[other_user_id] || { 'ext-display-name':'unknown', unknown:true };
						var hint_html = '<i>'+htmlspecialchars(other_user['ext-display-name'])+'</i>';
						if( other_user.unknown ) hint_html += ' '+mjt('ms-hint-email-of-existing-user-acct-status-is-unknown');
						else if( !other_user.active ) hint_html += ' '+mjt('ms-hint-email-of-existing-user-acct-status-is-inactive');
						var $hint_span = $('<span class="hint-block"></span>')
							.attr('data-user_id',other_user_id)
							.html(hint_html+' ')
							.toggleClass('inactive',!other_user.unknown && !other_user.active)
							.appendTo($hint_elem);
						if( !other_user.unknown && other_user.active ) {
							$('<button class="button-secondary" type="button">'+mjt('ms-user2user-button')+'</button>')
								.appendTo($hint_span)
								.on('click',function(e) {
									$hint_elem.empty();
									$('#ms-rcpt').val(other_user_id).trigger('change');
								});
						}
					}
				},
				null,
				null,
				true,
				function _on_complete() {
					_resolve_validation_pending_state($input_elem);
				}
			);
		}


		function query_rcpts_permissions( rcpt_user_id, success_cb ) {
			// build list of "relevant" acl_action ids
			var acl_actions = [];
			for( var p in j.permissions ) {
				if( !j.permissions.hasOwnProperty(p) ) continue;
				acl_actions.push(p);
			}
			startProgress();
			$.postJSON('json/media/send-rcpt_info', 'rcpt_user_id='+(rcpt_user_id==='guest'?'0':rcpt_user_id)+'&acl_actions='+encodeURIComponent(acl_actions.join(','))+'&media_ids='+encodeURIComponent(all_media_ids.join(',')), function(j2) {
				stopProgress();
				if( j2 && j2.hasOwnProperty('permissions') ) {
					success_cb(j2.permissions);
				}
			} );
		}

		function call_list_callback_with_perms( selected_val ) {

			function toggle_further_views( show ) {
				// update form view states
				$('#ms-c-mail-data,#ms-c-actions').toggle( show );
				$('#ms-c-notifications').toggle( show && mj.send.notify_rcpts_editable );
				$('#ms-c-plugin-data').toggle( show && !!pluginContext );
			}


			var ms_c_list = $('#ms-c-list');

			var perms_success_cb = function _perms_success_cb( rcpt_perms ) {
				// no need to rebuild when we habe multiple rcpts
				// (its only required when single-user changes, because of its perms..)
				var skip_rebuild = rcpt_perms===null && !ms_c_list.data('had_rcpt_perms');
				if( !skip_rebuild ) {
					// clear & re-build file list
					var detached_ms_list = clear_file_list(true);
					list_callback(detached_ms_list,j,rcpt_perms);
					ms_c_list
						.data('had_rcpt_perms',rcpt_perms!=null)
						.append(detached_ms_list)
						.show();
				}
				// update form view states
				toggle_further_views(true);
				// run form validations
				update_form_validation_state();
			};

			if( selected_val==='guest' ) {
				// guest
				// -> query and USE rcpt_perms
				query_rcpts_permissions(selected_val,perms_success_cb);

			} else {
				// initial entry or actual user account selected
				var saved_rcpts_count = _get_saved_rcpts_count();

				var rcpt_list_hint = '';
				if( saved_rcpts_count===0 ) rcpt_list_hint = mjt('ms-hint-rcpt-list-empty');
				else if( saved_rcpts_count===1 ) rcpt_list_hint = mjt('ms-hint-rcpt-list-1');
				else rcpt_list_hint = mjt('ms-hint-rcpt-list').replace(/%1/,saved_rcpts_count);
				$('#ms-c-rcpt-list').show().find('.hint').text( rcpt_list_hint );

				if( saved_rcpts_count===1 ) {
					// exactly ONE saved rcpt
					// -> query and USE rcpt_perms of FIRST user in saved data, NOT of user eventually identified by selected_val
					var saved_rcpts_data = _get_saved_rcpts_data();
					query_rcpts_permissions(saved_rcpts_data[0][0],perms_success_cb);
				} else if( saved_rcpts_count > 1 ) {
					// at least two saved rcpts
					// -> skip query'ing rcpt_perms
					perms_success_cb(null);
				} else {
					// no saved rcpts
					// -> no rcpt_perms available
					clear_file_list();
					ms_c_list.data('had_rcpt_perms',true);
					toggle_further_views(false);
					// run form validations
					update_form_validation_state();
				}
			}
		}


		function on_change_rcpt( evt ) {
			var selected_val = $(this).val();

			$('#ms-c-user-data,#ms-c-guest-data').hide();
			$('#ms-c-user-data .ms-add-more-rcpts').remove();

			if( selected_val==='' ) {
				// initial entry selected

				// NOTE: visibility of #ms-c-rcpt-list stays as-is here ..

			} else if( selected_val==='guest' ) {
				// guest selected

				// no rcpt-list for send-to-guest ..
				$('#ms-c-rcpt-list').hide();
				// remove saved selected ids ..
				$('#ms-rcpt-list .ms-rcpt-block').remove();

				// prepare guest data form elements
				$('#ms-guest2user-button').hide();
				$('#ms-c-guest-data').show();
				$('#ms_guest_email')
					.off('.mjMVSend')
					.on('input.mjMVSend',$.debounce(125,function(evt) {
						update_form_validation_state(false,evt);
					}));

				if( !$('#ms_guest_expires').data('select2') ) $('#ms_guest_expires').select2();
				if( !$('#ms_guest_locale').data('select2') ) $('#ms_guest_locale').select2();
				$('#ms_guest_expires')
					.off('.mjMVSend')
					.on('change.mjMVSend',function() {
						update_mail_subject(j.mail_subject_guest,null,pluginContext);
					} );

				$('#ms_guest_first_name,#ms_guest_last_name')
					.off('.mjMVSend')
					.on('input.mjMVSend',$.debounce(125,function(evt) {
						update_mail_subject(j.mail_subject_guest,null,pluginContext);
						update_form_validation_state(false,evt);
					}));

				$('#ms_guest_email').trigger('input').focus();

			} else {
				// actual user account selected
				var selected_user_id = parseInt(selected_val,10);
				var user = userhash[selected_user_id];

				// show rcpt-list for send-to-user ..
				$('#ms-c-rcpt-list').show();

				var get_expiration_dt_from_offset = function( now_dt_num, expires_offset ) {
					var dt_obj = new Date(now_dt_num);
					dt_obj.setTime( dt_obj.getTime() + (expires_offset*60*60*1000) );
					var dt_str = MDTimezones.mj_date_object_to_datetime_string(dt_obj);
					return dt_str;
				};

				// prepare user data form elements
				var now_dt_num = Date.now();
				var show_user_data_form_elems = false;
				if( user.expires!='' ) {
					var ms_user_expires_extend = $('#ms_user_expires_extend');
					var ms_user_expires = $('#ms_user_expires');
					var u_expires_dt_obj = MDTimezones.mj_datetime_to_date_object(MDTimezones.xpl_datetime(user.expires));
					var u_first_enabled_option_val = null;
					ms_user_expires.find('option').each( function() {
						var oself = $(this);
						var oval = oself.attr('value');
						var o_expire_dt_obj = new Date(now_dt_num);
						o_expire_dt_obj.setTime( o_expire_dt_obj.getTime() + (oval*60*60*1000) );
						if( o_expire_dt_obj.getTime() - u_expires_dt_obj.getTime() > 0 ) {
							if( u_first_enabled_option_val===null ) u_first_enabled_option_val = oval;
							oself.prop('disabled',false);
						} else {
							oself.prop('disabled',true);
						}
					} );
					ms_user_expires_extend.prop('checked',true).off('.mjMVSend').on( 'click.mjMVSend', function() {
						var checked = $(this).prop('checked');
						$('#ms_user_expires-row').toggle( !!checked );
						var btn_label = checked ? mjt('ms-add-rcpt-and-expand-expiration-button') : mjt('ms-add-rcpt-keep-expiration-button');
						$('#ms-c-user-data .ms-add-more-rcpts > .label').html(btn_label);
					});
					ms_user_expires.off('.mjMVSend').on( 'change.mjMVSend', function() {
						var expires_offset = $(this).val();
						var dt_str = get_expiration_dt_from_offset(now_dt_num,expires_offset);
						$('#ms_user_expires-additional-sfx').text( mjt('ms-user-expires-target').replace(/%1/,MDLocale.fmt_date(dt_str)) );
						update_mail_subject(j.mail_subject_user,user,pluginContext);
					});
					if( u_first_enabled_option_val!==null ) {
						show_user_data_form_elems = true;
						if( !ms_user_expires.data('select2') ) ms_user_expires.select2();
						ms_user_expires.val(u_first_enabled_option_val).change();
					}
				}
				update_mail_subject(j.mail_subject_user,user,pluginContext);


				var add_selected_user_to_rcpt_list = function _add_selected_user_to_rcpt_list( expires_offset ) {
					var email = user.userdata.hasOwnProperty('email') ? str_trim(user.userdata.email) : 'unknown';
					var expires_text = '';
					if( expires_offset ) {
						expires_text = mjt('ms-valid-until') + ' ' + MDLocale.fmt_datetime(get_expiration_dt_from_offset(now_dt_num,expires_offset)) + ' ' + mjt('ms-valid-until-extended');
					} else if( user.expires!='' ) {
						expires_text = mjt('ms-valid-until') + ' ' + MDLocale.fmt_datetime(MDTimezones.datetime_utc2local(user.expires));
					}
					$('<span class="ms-rcpt-block" style="display:none"><span class="remove delete-link" tabindex="0">&times;</span><span class="name"></span><span class="email"></span><span class="expires"></span></span>')
						.data('user_id',selected_user_id)
						.data('expires',expires_offset)
						.find('> .name').text(user['display-name']).end()
						.find('> .email').text(email).end()
						.find('> .expires').text(expires_text).end()
						.appendTo( '#ms-rcpt-list' )
						.fadeIn( 'fast', function()  {
							var prev_selected_val = on_after_rcpt_list_changed('add',selected_user_id);
							call_list_callback_with_perms(prev_selected_val);
						} );
				};

				var add_selected_user_to_rcpt_list_expand_expiry = function() {
					var extend = $('#ms_user_expires_extend').prop('checked');
					var expires_offset = extend ? ( $('#ms_user_expires').not(':disabled').filter(':visible').val() || 0 ) : 0;
					add_selected_user_to_rcpt_list(expires_offset);
				};

				$('#ms_user_expires-row').toggle( $('#ms_user_expires_extend').prop('checked') );
				$('#ms_user_expires').prop('disabled',!show_user_data_form_elems);
				if( show_user_data_form_elems ) {
					// let user select expire offset, before append rcpt to rcpt list ...
					$('#ms-c-user-data').show();
					$('#ms_user_expires').focus();
					var btn_label = $('#ms_user_expires_extend').prop('checked') ? mjt('ms-add-rcpt-and-expand-expiration-button') : mjt('ms-add-rcpt-keep-expiration-button');
					$('<button class="button-secondary ms-add-more-rcpts" type="button">'+btn_label+'</button>')
						.appendTo('#ms-c-user-data')
						.on('click',add_selected_user_to_rcpt_list_expand_expiry);
				} else {
					// add to rcpt list
					// // -> actually: this is defered to next frame (to break up recursion from change events of #ms-rcpt ..)
					requestAnimationFrame(add_selected_user_to_rcpt_list_expand_expiry);
					return;
				}

			}

			call_list_callback_with_perms(selected_val);

		} // function on_change_rcpt


		function on_after_rcpt_list_changed( what, rcpt_user_id ) {
			var ms_rcpt = $('#ms-rcpt');
			var selected_val = ms_rcpt.val();

			// selectively update rcpt select ..
			if( what==='remove' ) ms_rcpt.find('option[value="'+rcpt_user_id+'"]').prop('disabled',false);
			else if( what==='add' ) ms_rcpt.find('option[value="'+rcpt_user_id+'"]').prop('disabled',true);
			if( j.send_to_guest_enabled ) ms_rcpt.find('option[value="guest"]').prop('disabled',_get_saved_rcpts_count()>0);

			// reset form visible states
			$('#ms-c-user-data,#ms-c-guest-data').hide();

			// set initial item in select
			ms_rcpt.val('').trigger('change.select2').focus();

			// return value of selected_val before it being reset to initial
			return selected_val;
		}

		// prepare rcpt select ...
		build_rcpt_select($('#ms-rcpt'),j.userlist,j.send_to_guest_enabled,on_change_rcpt);

		// bind handlers for .remove buttons in rcpt-list ...
		$('#ms-rcpt-list')
			.off()
			.on('click','> .ms-rcpt-block > .remove',function() {
				var ms_rcpt_block = $(this).closest('.ms-rcpt-block');
				var deleted_user_id = ms_rcpt_block.data('user_id');
				ms_rcpt_block.remove();

				var prev_selected_val = on_after_rcpt_list_changed('remove',deleted_user_id);
				call_list_callback_with_perms(prev_selected_val);
			});


		// prepare file list
		var file_list_default_opened = all_media_ids.length < 100; // closed by default when list contains 100+ items
		$('#ms-list').toggle(file_list_default_opened);
		$('#ms-c-list-link')
			.text( file_list_default_opened ? mjt('ms-media-hide') : mjt('ms-media-show') )
			.off('click')
			.on( 'click', function() {
				var l = $('#ms-list');
				var show = l.css('display')!='block';
				l.toggle( show );
				$(this).text( show ? mjt('ms-media-hide','!') : mjt('ms-media-show','!') );
			} );


		// prepare mail form
		$('#ms_lb_title_row').show(!!lb_title_callback);
		if( lb_title_callback ) lb_title_callback(j);
		$('#ms_mail_subject').val( mjt('ms-mail-subject-default').replace('%1',m_sender['short-display-name']) );
		$('#ms_mail_text').val('');

		$('#ms-c-context').empty().hide();

		if( pluginContext ) {
			MPlugins.callOnAllPluginsOfType('MediaSendView','setupSendView',true,$('#ms-form-send-as-lightbox'),$('#ms-c-context'),m_sender,pluginContext);
		}

		// notification rcpts...
		if( mj.send.notify_rcpts_editable && mj.send.notify_rcpts_add_sender ) {
			$('#ms_notifications_rcpts').val(m_sender.userdata&&m_sender.userdata['email']?str_trim(m_sender.userdata['email'])+'\n':'');
		} else {
			$('#ms_notifications_rcpts').val('');
		}

		$('#ms_lb_title,#ms_mail_subject,#ms_notifications_rcpts')
			.off('.mjMVSend')
			.on('input.mjMVSend',$.debounce(125,function(evt) {
				var $input_elem = $(this).filter(':visible').not(':disabled');
				if( $input_elem.length ) {
					update_form_validation_state(false,evt);
				}
			}));


		// submit function, validation etc.
		$('#ms-form-send-as-lightbox')
			.off()
			.submit( function( evt ) {

				// when #ms-list is hidden, then form_fields_1 will not contain the "acl_actions" checkboxes
				// so, just show it now ..
				if( $('#ms-list').css('display')!='block' ) {
					$('#ms-c-list-link').click();
				}


				update_form_validation_state( true, evt, function _on_validation_success( form_fields_1 ) {

					var plugins_extra_postdata = {};
					if( pluginContext ) {
						MPlugins.callOnAllPluginsOfType('MediaSendView','beforeSubmit',true,$('#ms-form-send-as-lightbox'),form_fields_1,plugins_extra_postdata,pluginContext);
					}

					startProgress();

					var form_fields_2 = form_fields_1.filter('[type!=checkbox]');
					var form_fields_checkboxes = form_fields_1.filter('[type=checkbox]:checked');
					form_fields_2 = form_fields_2.add(form_fields_checkboxes);

					var tzname = MDTimezones.getTimezoneName();
					var postdata = $.param(form_fields_2)
									+extra_postdata_callback()
									+'&tz-name='+tzname;
					if( !$.isEmptyObject(plugins_extra_postdata) ) postdata += '&'+$.param(plugins_extra_postdata);

					if( _get_saved_rcpts_count() > 0 ) {
						var all_rcpts_data = _get_saved_rcpts_data();
						postdata += '&rcpts_json='+encodeURIComponent(JSON.stringify(all_rcpts_data));
					}

					$.postJSON('json/media/send-lightbox', postdata, function(j2) {
						stopProgress();
						if( j2.success ) {
							showInfoToast( mjt('ms-send-success') );
							$('#ms-form').dialog('destroy');

							if( pluginContext ) {
								MPlugins.callOnAllPluginsOfType('MediaSendView','afterSubmit',true,j2,pluginContext);
							}

						} else if( j2.error && ( j2.error.substr(0,36)=='send failed: username already in use' || j2.error.substr(0,43)=='send failed: failed to add new user account' ) ) {
							// errors related to guest account creation:
							$('#ms_guest_email').addClass('error').select();
							var matches = j2.error.match(/\(existing_user_id=(\d+)\)/i);
							if( matches && matches.length>=2 && matches[1] ) {
								// user with given email already exists
								var existing_user_id = matches[1];
								big_confirm_box(
									mjt('ms-send-failed-title'),
									mjt('ms-send-failed-text-user-exists'),
									function confirm_cb() {
										$('#ms-rcpt').val(existing_user_id).trigger('change');
									},
									null,
									function cancel_cb() {
										$('#ms_guest_email').select();
									}
								);
							} else {
								// user with given email already exists
								error_box( mjt('ms-send-failed-title'), mjt('ms-send-failed-text-user-exists') );
							}
						} else {
							// other error
							//$('#ms-form').dialog('destroy');
							if( j2.error ) showWarningToast( j2.error );
							error_box( mjt('ms-send-failed-title'), mjt('ms-send-failed-text') );
						}
					} );
				} );

				return false;
			} );

		// show dialog
		$('#ms-form').dialog( {
			width: function(win_size) {
				return Math.min(getPreferedMaxDialogWidth()-40,1000);
			},
			height: function(win_size) {
				return Math.min(getPreferedMaxDialogHeight()+0,1200);
			},
			modal: true,
			resizable: false,
			close: function(evt,ui) {
				$(this).dialog('destroy');
			},
			open: function(evt,ui) {
				update_form_validation_state(false,evt);
				if( dlg_open_callback ) dlg_open_callback();
			},
		} ).show();
	}


	function openMediaIDs( media_ids, lb_title, send_mode, pluginContext ) {
		if( media_ids.length===0 ) return;
		_reset_ms();
		switch(send_mode) {
		case 'attachment':
			$('#ms-form-send-as-lightbox').hide();
			$('#ms-form-send-as-link').hide();
			$('#ms-form-send-as-attachment').show();
			openMediaIDs_SendAsAttachment( media_ids.slice(), lb_title, function() {
				_setup_dialog_tabs(media_ids,lb_title,'attachment',pluginContext);
			}, pluginContext );
			break;
		case 'link':
			$('#ms-form-send-as-attachment').hide();
			$('#ms-form-send-as-lightbox').hide();
			$('#ms-form-send-as-link').show();
			openMediaIDs_SendAsLink( media_ids.slice(), lb_title, function() {
				_setup_dialog_tabs(media_ids,lb_title,'link',pluginContext);
			}, pluginContext );
			break;
		default:
			$('#ms-form-send-as-attachment').hide();
			$('#ms-form-send-as-link').hide();
			$('#ms-form-send-as-lightbox').show();
			openMediaIDs_SendAsLightbox( media_ids.slice(), lb_title, function() {
				_setup_dialog_tabs(media_ids,lb_title,'lightbox',pluginContext);
			}, pluginContext );
		}
	}



	function _update_item_size_estimation( select_node, delay_cnt ) {
		var file_node = select_node.closest('.ms-file-item');
		var node_mid = file_node.attr('media_id');
		var node_dlf_id = select_node.val();
		var trg = file_node.find('.ms-saa-item-size-estimation');
		trg.html('<img src="'+htmlspecialchars(mj.skin_files['ajax-loader'],true,true)+'" style="vertical-align:middle" />');

		window.setTimeout( function() {
			$.postJSON('json/media/send-filesize_estimation', 'media_id='+encodeURIComponent(node_mid)+'&dlf_id='+encodeURIComponent(node_dlf_id), function(j_size_est) {
				if( j_size_est && j_size_est.success ) {
					if( j_size_est.size==-1 ) {
						trg.html(mjt('ms-saa-size-na'));
					} else {
						var s=j_size_est.size, s_base64=Math.round(s*1.34);
						trg.html(mjt('ms-saa-size-spec').replace('%1',MDLocale.fmt_filesize(s)).replace('%2',MDLocale.fmt_filesize(s_base64)));
					}
				} else {
					trg.html(mjt('ms-saa-size-na'));
				}
			});
		}, 33+20*delay_cnt );
	}

	function openMediaIDs_SendAsAttachment( media_ids, lb_title, dlg_open_callback, pluginContext ) {
		var ms_saa_list = $('#ms-saa-list');
		var dlf, idx;

		startProgress();
		$.postJSON( 'json/media/send-info', 'media_ids='+encodeURIComponent(media_ids.join(','))+'&get_download_formats=1', function(j) {
			stopProgress();

			var i2;
			var media_class_count = {}; // hash mc=>cnt, ..
			var _update_mc_format_select_SendAsAttachment = function() {
				// get selected formats & update "download filenames" of items
				var dlfs_by_mc = {}; // hash mc=>hash(dlf_id=>1,dlf_id=>1,..), ..
				ms_saa_list.find('> div.ms-saa-real-file-item').each( function() {
					var file_node = $(this);
					var node_mid = file_node.attr('media_id');
					var node_mc = j.meta && j.meta[node_mid] && j.meta[node_mid][-1] ? j.meta[node_mid][-1][0] : 0;
					var fn;
					if( file_node.hasClass('disabled') ) {
						fn = '-';
					} else {
						const dlf_id = file_node.find('>.ms-item-menu>select').val();
						if( !dlfs_by_mc.hasOwnProperty(node_mc) ) dlfs_by_mc[node_mc] = {};
						dlfs_by_mc[node_mc][dlf_id] = 1 + ( dlfs_by_mc[node_mc].hasOwnProperty(dlf_id) ? dlfs_by_mc[node_mc][dlf_id] : 0 );
						fn = j.download_filenames[node_mid] && j.download_filenames[node_mid][dlf_id] ? j.download_filenames[node_mid][dlf_id] : '-';
					}
					// update "download filename"
					file_node
						.children('.ms-item-filename').text(fn).end()
						.children('input[type=hidden]').val(fn);
				} );
				// update format selection boxes
				var avl_media_id_count = ms_saa_list.find('> div.ms-saa-real-file-item > .ms-item-menu > select').length;
				$('#ms-saa-format-box').toggle( avl_media_id_count>1 );
				if( avl_media_id_count>1 ) {
					for( var mc in media_class_count ) {
						if( media_class_count.hasOwnProperty(mc) ) {
							if( media_class_count[mc]==0 || !dlfs_by_mc.hasOwnProperty(mc) ) {
								$('#ms-saa-format-'+mc).remove();
							} else {
								var fmt_mc_sbox = $('#ms-saa-format-'+mc+' > select'),
									sel_dlf_cnt = Object.size(dlfs_by_mc[mc]);
								if( sel_dlf_cnt==1 ) {
									// only one dlf selected...
									if( fmt_mc_sbox.children('option[value=0]').length ) fmt_mc_sbox.prop('options').length --; // IE7 compatible way
									for( var dlf_id in dlfs_by_mc[mc] ) {
										if( !dlfs_by_mc[mc].hasOwnProperty(dlf_id) ) continue;
										fmt_mc_sbox.val(dlf_id).trigger('change.select2');
									}
								} else {
									// multiple dlf selected...
									if( fmt_mc_sbox.children('option[value=0]').length==0 ) {
										// IE7 compatible way
										var opts = fmt_mc_sbox.prop('options');
										opts[opts.length] = new Option(mjt('ms-saa-format-opt-0'),'0');
										fmt_mc_sbox.children('option[value=0]').addClass('other');
									}
									fmt_mc_sbox.val('0').trigger('change.select2');
								}
							}
						}
					}
				}
				return avl_media_id_count;
			};

			// prepare media list
			var ms_saa_template_file_item = $('#ms-saa-template-file-item');
			for( var i=0; i<media_ids.length; ++i ) {
				var mid = media_ids[i];
				var media_class = j.meta && j.meta[mid] && j.meta[mid][-1] ? j.meta[mid][-1][0] : 0;
				var title = j.meta && j.meta[mid] && j.meta[mid][101] ? j.meta[mid][101][0] : '';
				title = title=='' ? ('ID '+mid) : (title+' (ID '+mid+')');
				var file_node = ms_saa_template_file_item.clone(false)
					.addClass('ms-saa-real-file-item')
					.attr({'id':'ms-saa-file-'+mid,'media_id':mid})
					.children('.ms-item-media-id').text(title).end()
					.append('<input type="hidden" name="media_fn['+mid+']" value="" />')
					.appendTo(ms_saa_list)
					.show();

				// add thumbnail
				MThumbnails.createOnTarget(
					file_node.children('.ms-item-thumb')[0],
					{
						media_id: mid,
						width: 55,
						height: 45,
						meta: j.meta[mid]||{},
						thumb_loader_anim: true,
					}
				);

				// add format select options
				var fmt_sbox_SendAsAttachment = file_node
					.find('>.ms-item-menu>select')
					.attr('name','media_dlf['+mid+']')
					.select2()
					.change( function() {
						_update_item_size_estimation($(this),0);
						_update_mc_format_select_SendAsAttachment();
					});


				var disabled_by_not_yet_incepted = (mid in j.disabled_by_not_yet_incepted && j.disabled_by_not_yet_incepted[mid]);
				var disabled_by_expiry = (mid in j.disabled_by_expiry && j.disabled_by_expiry[mid]);
				var avl_dlf_cnt = 0;

				if( disabled_by_not_yet_incepted || disabled_by_expiry ) {
					// not available for download & not available for send...
				} else {
					for( i2=0; i2<j.download_formats.length; ++i2 ) {
						dlf = j.download_formats[i2];
						if( dlf.media_class==media_class && j.permissions[dlf.acl_action] && j.permissions[dlf.acl_action][mid] ) {
							$('<option />').attr('value',dlf.id).text(dlf.name).appendTo(fmt_sbox_SendAsAttachment);
							avl_dlf_cnt ++;
						}
					}
				}

				if( avl_dlf_cnt===0 ) {
					// mark as disabled
					file_node
						.addClass('disabled')
						.children('.ms-item-menu')
						.children('select').replaceWith(mjt('ms-saa-format-item-na')).end()
						.children('.ms-item-format-select').remove().end()
						.children('input[type=hidden]').remove();
				} else {
					// count
					media_class_count[media_class] = 1 + ( media_class_count.hasOwnProperty(media_class) ? media_class_count[media_class] : 0 );
				}

				// add events handlers
				file_node.find('>.ms-item-menu>.ms-item-remove').click( function(e) {
					var fnd = $(this).closest('.ms-file-item');
					var m = fnd.attr('media_id');
					var mc = j.meta && j.meta[m] && j.meta[m][-1] ? j.meta[m][-1][0] : 0;
					if( !fnd.hasClass('disabled') ) media_class_count[mc] --;
					fnd.remove();
					for( var x=0; x<media_ids.length; x++ ) {
						if( media_ids[x]==m ) {
							media_ids.splice(x,1);
							break;
						}
					}
					if( media_ids.length==0 ) $('#ms-form').dialog('destroy');
					else _update_mc_format_select_SendAsAttachment();
				} );
			}

			// prepare format selection box
			var mc_do_len = mj.mc_display_order.length;
			for( idx=0; idx<mc_do_len; ++idx ) {
				var mc = mj.mc_display_order[idx];
				if( media_class_count.hasOwnProperty(mc) && media_class_count[mc]>0 ) {
					$('#ms-saa-format-template').clone(false)
						.attr('id','ms-saa-format-'+mc)
						.find('.label').text(mj.mc_names[mc]+': ').end()
						.find('select').attr('name','ms-saa-format-mc-'+mc).end()
						.appendTo('#ms-saa-format-list')
						.show();
					for( i2=0; i2<j.download_formats.length; ++i2 ) {
						dlf = j.download_formats[i2];
						if( dlf.media_class != mc ) continue;
						$('<option />').attr('value',dlf.id).text(dlf.name)
							.appendTo('#ms-saa-format-'+mc+' > select');
					}
					$('#ms-saa-format-'+mc+' > select').select2().change( function() {
						var dlf_id = $(this).val();
						var delay_cnt = 0;
						ms_saa_list.find('> div.ms-saa-real-file-item > .ms-item-menu > select').each( function() {
							var fmt_sbox_SendAsAttachment = $(this);
							if( fmt_sbox_SendAsAttachment.children('option[value='+dlf_id+']').length>0 ) {
								fmt_sbox_SendAsAttachment.val(dlf_id).trigger('change.select2');
								_update_item_size_estimation(fmt_sbox_SendAsAttachment,++delay_cnt);
							}
						});
						requestAnimationFrame(_update_mc_format_select_SendAsAttachment);
					});
				}
			}

			// trigger format selection once..
			const avl_media_id_cnt = _update_mc_format_select_SendAsAttachment();
			$('#ms-saa-c-mail,#ms-saa-c-actions').toggle(avl_media_id_cnt!==0);

			// trigger calculation of size estimations per item once
			requestAnimationFrame( function() {
				var delay_cnt = 0;
				ms_saa_list.find('> div.ms-saa-real-file-item > .ms-item-menu > select').each( function() {
					_update_item_size_estimation($(this),++delay_cnt);
				});
			} );

			// prepare mail form
			m_sender = {
				'short-display-name': '',
				userdata: {},
			};
			for( idx in j.userlist ) {
				if( !j.userlist.hasOwnProperty(idx) ) continue;
				var u = j.userlist[idx];
				if( u.user_id==j.self_uid ) {
					m_sender = u;
					break;
				}
			}

			var def_mail_subject = j.mail_subject_attachment.replace('%%sender-display-name%%',m_sender['short-display-name']);
			var def_mail_text = '';

			$('#ms-form-send-as-attachment')
				.find('[name=mail-subject]').val(def_mail_subject).end()
				.find('[name=mail-text]').val(def_mail_text).end();
			var _send_as_att_failed = function( j ) {
				if( j.error && j.error==='max size exceeded' ) {
					error_box(
						mjt('ms-send-failed-title'),
						mjt('ms-saa-send-max-size-exceeded-text','!')
							.replace(/\n/g,'<br />\n')
							.replace('%1',MDLocale.fmt_filesize(j.content_size))
							.replace('%2',MDLocale.fmt_filesize(j.max_size)),
						null,
						true
					);
				} else {
					if( j.error ) showWarningToast(j.error);
					error_box( mjt('ms-send-failed-title'), mjt('ms-saa-send-failed-text') );
				}
			};
			$('#ms-saa-c-notifications').toggle(mj.send.notify_rcpts_editable);
			if( mj.send.notify_rcpts_editable && mj.send.notify_rcpts_add_sender ) {
				$('#ms_saa_notifications_rcpts').val(m_sender.userdata&&m_sender.userdata['email']?str_trim(m_sender.userdata['email'])+'\n':'');
			} else {
				$('#ms_saa_notifications_rcpts').val('');
			}
			// submit function, validation etc.
			$('#ms-form-send-as-attachment').off().submit( function() {
				var f = $(this),
					err = [];
				if( !is_valid_email_list(f.find('[name=mail-rcpt]').val()) ) err.push(mjt('ms-saa-err-invalid-email'));
				if( str_trim(f.find('[name=mail-subject]').val())=='' ) err.push(mjt('ms-err-mail-subject'));
				if( mj.send.notify_rcpts_editable ) {
					var xvtmp = str_trim(f.find('[name=notifications-rcpts]').val());
					if( xvtmp!='' && !is_valid_email_list(xvtmp) ) err.push(mjt('ms-saa-err-invalid-notifications-rcpts-email'));
				}
				if( err.length ) {
					error_box(mjt('ms-err-title'),mjt('ms-err-text'),err);
				} else {
					var formdata = f.serialize();
					var avl_media_id_count = ms_saa_list.find('> div.ms-saa-real-file-item > .ms-item-menu > select').length;
					if( avl_media_id_count==0 ) {
						// no files available, show info
						error_box( mjt('ms-saa-send-na-title'), mjt('ms-saa-send-na-text') );
					} else if( avl_media_id_count==1 ) {
						// send mail, with single file attached
						startProgress();
						$.postJSON('json/media/send-attachment', formdata, function(j_send) {
							stopProgress();
							$('#ms-form').dialog('destroy');
							if( j_send.success ) {
								showInfoToast( mjt('ms-send-success') );
							} else {
								_send_as_att_failed(j_send);
							}
						});
					} else if( avl_media_id_count>1 ) {
						// create zip archive
						startProgress();
						$.postJSON('json/media/send-attachment_create', formdata, function(j_create) {
							saa_archive_id = j_create.archive_id;
							// wait until zip archive is ready
							var check_archive_ready = function( initial ) {
								if( initial || $('#ms-form').dialog('isOpen') ) {
									if( saa_archive_id==null ) return; // ignore
									$.postJSON2('json/media/send-attachment_ready', 'archive_id='+encodeURIComponent(saa_archive_id), function(j_ready) {
										if( j_ready.ready && j_ready.ready=='1' ) {
											// send mail, with zip archive attached
											var tmp_archive_id = saa_archive_id;
											saa_archive_id = null;
											$.postJSON('json/media/send-attachment', formdata+'&archive_id='+encodeURIComponent(tmp_archive_id), function(j_send) {
												stopProgress();
												if( j_send.success ) {
													$('#ms-form').dialog('destroy');
													showInfoToast( mjt('ms-send-success') );
												} else {
													_send_as_att_failed(j_send);
												}
											}); // json/media/send-attachment
										} else if( j_ready.error ) {
											// stop
											stopProgress();
											showWarningToast(j_ready.error);
											saa_archive_id = null;
										} else {
											// check again
											setTimeout( function() {
												check_archive_ready(false);
											}, 500 );
										}
									}, function() {
										// timeout from server
										setTimeout( function() {
											check_archive_ready(false);
										}, 1000 );
									}, function() {
										// error from server
										setTimeout( function() {
											check_archive_ready(false);
										}, 1000 );
									} );
								}
							};
							check_archive_ready(true);
						} );
					}
				}
				return false;
			});
			// show dialog
			$('#ms-form').dialog( {
				width:		function(win_size) {
					return Math.min(getPreferedMaxDialogWidth()-40,800);
				},
				height:		function(win_size) {
					return Math.min(getPreferedMaxDialogHeight()+0,1200);
				},
				modal:		true,
				resizable:	false,
				open:		function(ev,ui) {
					if( dlg_open_callback ) dlg_open_callback();
				},
				close:		function(ev,ui) {
					$(this).dialog('destroy');
				},
			} ).show();
		});
	}

	function openMediaIDs_SendAsLink( media_ids, lb_title, dlg_open_callback, pluginContext ) {
		var ms_saa_list = $('#ms-sal-list');
		var dlf, idx;

		startProgress();
		$.postJSON( 'json/media/send-info', 'media_ids='+encodeURIComponent(media_ids.join(','))+'&get_download_formats=1&get_userlist=1', function(j) {
			stopProgress();

			var i2;
			var media_class_count = {}; // hash mc=>cnt, ..
			var _update_mc_format_select_SendAsLink = function() {
				// get selected formats & update "download filenames" of items
				var dlfs_by_mc = {}; // hash mc=>hash(dlf_id=>1,dlf_id=>1,..), ..
				ms_saa_list.find('> div.ms-sal-real-file-item').each( function() {
					var file_node = $(this);
					var node_mid = file_node.attr('media_id');
					var node_mc = j.meta && j.meta[node_mid] && j.meta[node_mid][-1] ? j.meta[node_mid][-1][0] : 0;
					var fn;
					if( file_node.hasClass('disabled') ) {
						fn = '-';
					} else {
						const dlf_id = file_node.find('>.ms-item-menu>select').val();
						if( !dlfs_by_mc.hasOwnProperty(node_mc) ) dlfs_by_mc[node_mc] = {};
						dlfs_by_mc[node_mc][dlf_id] = 1 + ( dlfs_by_mc[node_mc].hasOwnProperty(dlf_id) ? dlfs_by_mc[node_mc][dlf_id] : 0 );
						fn = j.download_filenames[node_mid] && j.download_filenames[node_mid][dlf_id] ? j.download_filenames[node_mid][dlf_id] : '-';
					}
					// update "download filename"
					file_node
						.children('.ms-item-filename').text(fn).end()
						.children('input[type=hidden]').val(fn);
				} );
				// update format selection boxes
				var avl_media_id_count = ms_saa_list.find('> div.ms-sal-real-file-item > .ms-item-menu > select').length;
				$('#ms-sal-format-box').toggle( avl_media_id_count>1 );
				if( avl_media_id_count>1 ) {
					for( var mc in media_class_count ) {
						if( media_class_count.hasOwnProperty(mc) ) {
							if( media_class_count[mc]==0 || !dlfs_by_mc.hasOwnProperty(mc) ) {
								$('#ms-sal-format-'+mc).remove();
							} else {
								var fmt_mc_sbox = $('#ms-sal-format-'+mc+' > select'),
									sel_dlf_cnt = Object.size(dlfs_by_mc[mc]);
								if( sel_dlf_cnt==1 ) {
									// only one dlf selected...
									if( fmt_mc_sbox.children('option[value=0]').length ) fmt_mc_sbox.prop('options').length --; // IE7 compatible way
									for( var dlf_id in dlfs_by_mc[mc] ) {
										if( !dlfs_by_mc[mc].hasOwnProperty(dlf_id) ) continue;
										fmt_mc_sbox.val(dlf_id).trigger('change.select2');
									}
								} else {
									// multiple dlf selected...
									if( fmt_mc_sbox.children('option[value=0]').length==0 ) {
										// IE7 compatible way
										var opts = fmt_mc_sbox.prop('options');
										opts[opts.length] = new Option(mjt('ms-sal-format-opt-0'),'0');
										fmt_mc_sbox.children('option[value=0]').addClass('other');
									}
									fmt_mc_sbox.val('0').trigger('change.select2');
								}
							}
						}
					}
				}
				return avl_media_id_count;
			};

			// prepare media list
			var ms_saa_template_file_item = $('#ms-sal-template-file-item');
			for( var i=0; i<media_ids.length; ++i ) {
				var mid = media_ids[i];
				var media_class = j.meta && j.meta[mid] && j.meta[mid][-1] ? j.meta[mid][-1][0] : 0;
				var title = j.meta && j.meta[mid] && j.meta[mid][101] ? j.meta[mid][101][0] : '';
				title = title=='' ? ('ID '+mid) : (title+' (ID '+mid+')');
				var file_node = ms_saa_template_file_item.clone(false)
					.addClass('ms-sal-real-file-item')
					.attr({'id':'ms-sal-file-'+mid,'media_id':mid})
					.children('.ms-item-media-id').text(title).end()
					.append('<input type="hidden" name="media_fn['+mid+']" value="" />')
					.appendTo(ms_saa_list)
					.show();

				// add thumbnail
				MThumbnails.createOnTarget(
					file_node.children('.ms-item-thumb')[0],
					{
						media_id: mid,
						width: 55,
						height: 45,
						meta: j.meta[mid]||{},
						thumb_loader_anim: true,
					}
				);

				// add format select options
				var fmt_sbox_asLink = file_node
					.find('>.ms-item-menu>select')
					.attr('name','media_dlf['+mid+']')
					.select2()
					.change( function() {
						_update_mc_format_select_SendAsLink();
					});


				var disabled_by_not_yet_incepted = (mid in j.disabled_by_not_yet_incepted && j.disabled_by_not_yet_incepted[mid]);
				var disabled_by_expiry = (mid in j.disabled_by_expiry && j.disabled_by_expiry[mid]);
				var avl_dlf_cnt = 0;

				if( disabled_by_not_yet_incepted || disabled_by_expiry ) {
					// not available for download & not available for send...
				} else {
					for( i2=0; i2<j.download_formats.length; ++i2 ) {
						dlf = j.download_formats[i2];
						if( dlf.media_class==media_class && j.permissions[dlf.acl_action] && j.permissions[dlf.acl_action][mid] ) {
							$('<option />').attr('value',dlf.id).text(dlf.name).appendTo(fmt_sbox_asLink);
							avl_dlf_cnt ++;
						}
					}
				}

				if( avl_dlf_cnt===0 ) {
					// mark as disabled
					file_node
						.addClass('disabled')
						.children('.ms-item-menu')
						.children('select').replaceWith(mjt('ms-sal-format-item-na')).end()
						.children('input[type=hidden]').remove();
				} else {
					// count
					media_class_count[media_class] = 1 + ( media_class_count.hasOwnProperty(media_class) ? media_class_count[media_class] : 0 );
				}

				// add events handlers
				file_node.find('>.ms-item-menu>.ms-item-remove').click( function(e) {
					var fnd = $(this).closest('.ms-file-item');
					var m = fnd.attr('media_id');
					var mc = j.meta && j.meta[m] && j.meta[m][-1] ? j.meta[m][-1][0] : 0;
					if( !fnd.hasClass('disabled') ) media_class_count[mc] --;
					fnd.remove();
					for( var x=0; x<media_ids.length; x++ ) {
						if( media_ids[x]==m ) {
							media_ids.splice(x,1);
							break;
						}
					}
					if( media_ids.length==0 ) $('#ms-form').dialog('destroy');
					else _update_mc_format_select_SendAsLink();
				});
			}

			var valid_users = [];
			for( idx in j.userlist ) {
				if( !j.userlist.hasOwnProperty(idx) ) continue;
				var u = j.userlist[idx];
				if(u.userdata.email) valid_users.push(u);
			}

			// prepare format selection box
			var mc_do_len = mj.mc_display_order.length;
			for( idx=0; idx<mc_do_len; ++idx ) {
				var mc = mj.mc_display_order[idx];
				if( media_class_count.hasOwnProperty(mc) && media_class_count[mc]>0 ) {
					$('#ms-sal-format-template').clone(false)
						.attr('id','ms-sal-format-'+mc)
						.find('.label').text(mj.mc_names[mc]+': ').end()
						.find('select').attr('name','ms-sal-format-mc-'+mc).end()
						.appendTo('#ms-sal-format-list')
						.show();
					for( i2=0; i2<j.download_formats.length; ++i2 ) {
						dlf = j.download_formats[i2];
						if( dlf.media_class != mc ) continue;
						$('<option />').attr('value',dlf.id).text(dlf.name)
							.appendTo('#ms-sal-format-'+mc+' > select');
					}
					$('#ms-sal-format-'+mc+' > select').select2().change( function() {
						var dlf_id = $(this).val();
						ms_saa_list.find('> div.ms-sal-real-file-item > .ms-item-menu > select').each( function() {
							var fmt_sbox_asLink = $(this);
							if( fmt_sbox_asLink.children('option[value='+dlf_id+']').length>0 ) {
								fmt_sbox_asLink.val(dlf_id).trigger('change.select2');
							}
						});
						requestAnimationFrame(_update_mc_format_select_SendAsLink);
					});
				}
			}

			// trigger format selection once..
			const avl_media_id_cnt = _update_mc_format_select_SendAsLink();

			$('.ms-sal-limit').val(86400);
			$('.ms-sal-set-password').prop('checked', false);
			$('.ms-sal-targetlist').empty().hide();
			$('.ms-sal-send-email-submit button').prop('disabled', true);
			$('.ms-sal-send-email-input').val('');
			$('.ms-sal-add-mail').prop('disabled', true);
			$('.ms-sal-link-hash').val('');
			$('.ms-sal-password').val('');
			$('.ms-sal-manuell').text(mjt('ms-sal-limit-label-m')).val('-1');
			$('.ms-sal-email-group').empty();


			$('.ms-sal-copy-dashboard,.ms-sal-send-email-submit>button').prop('disabled',avl_media_id_cnt===0);


			var _handle_password_status = function() {
				$('.ms-sal-password-not-set').hide();
				$('.ms-sal-password-description').hide();
				$('.ms-sal-password-set').hide();
				$('.ms-sal-password').hide();
				$('.ms-sal-password-set-description').hide();
				if($('.mode-switch').mjWidget('get')) {
					$('.ms-sal-password-set').show();
					$('.ms-sal-password').val('').show().focus();
					$('.ms-sal-password-set-description').show();
				} else {
					$('.ms-sal-password-not-set').show();
					$('.ms-sal-password-description').show();
				}
			};
			var _handle_preview_status = function() {
				$('.ms-sal-preview-not-set').hide();
				$('.ms-sal-preview-set').hide();
				$('.ms-sal-preview-not-set-description').hide();
				$('.ms-sal-preview-set-description').hide();
				if($('.mode-switch2').mjWidget('get')) {
					$('.ms-sal-preview-set').show();
					$('.ms-sal-preview-set-description').show();
				} else {
					$('.ms-sal-preview-not-set').show();
					$('.ms-sal-preview-not-set-description').show();
				}
			};
			var _copyclipboard = function(someUrl, formdata) {
				startProgress();
				copyToClipboard(
					postToBackend(someUrl,formdata)
						.then( (obj) => {
							stopProgress();
							if(obj.success) {
								showInfoToastWithLink(mjt('ms-sal-copy-dashboard-done'), obj.link, {buttonCopy2Clipboard: true});
								$('.ms-sal-link-hash').val(obj.hash);
								return obj.link;
							}
							return '';
						} )
				);
			};
			$('.mode-switch').empty().mjWidget({
				type: 'bool-toggle-switch',
				name: 'set_password',
				value: false,
				change: function() {
					_handle_password_status();
				}
			});
			$('.mode-switch2').empty().mjWidget({
				type: 'bool-toggle-switch',
				name: 'set_preview',
				value: false,
				change: function() {
					_handle_preview_status();
				}
			});
			if( avl_media_id_cnt===0 ) {
				$('.ms-sal-add-mail').hide();
				$('.ms-sal-email-target').empty();
			} else {
				$('.ms-sal-add-mail').show();
				$('.ms-sal-email-target').empty().mjWidget({
					type: 'email-targetlist',
					button: $('.ms-sal-add-mail'),
					text: mjt('ms-sal-add-mail'),
					emailgroup: $('.ms-sal-email-group'),
					userlist: j.userlist,
					formsubmit: $('.ms-sal-send-email-submit button'),
					onsubmit: function() {
						let formdata = $('#ms-form-send-as-link').serialize();
						startProgress();
						$.postJSON( 'json/media/send-linkmail', formdata, function(j) {
							stopProgress();
							if(j.success) {
								//copyToClipboard(j.link);
								$('#ms-form').dialog('destroy');
								showInfoToast(mjt('ms-sal-send-success'));
							} else {
								showErrorToast(mjt('ms-sal-send-failure'));
							}
						});
					}
				});
			}
			_handle_password_status();
			_handle_preview_status();
			var limit_last_value = 86400;

			var today = new Date();
			var in6Month = new Date(new Date().setMonth(today.getMonth()+6));
			$('.ms-sal-limit-manuell').datepicker( {
				'dateFormat': 'yy-mm-dd',
				'minDate': today,
				'maxDate': in6Month,
				onClose: function() {
					let val = $('.ms-sal-limit option').filter(':selected').val();
					if(val == -1) $('.ms-sal-limit').val(limit_last_value);
					$('.ms-sal-limit-manuell').hide();
				}
			} ).change( function(evt) {
				let val = $( this ).datepicker( "getDate" );
				val.setHours(23);
				val.setMinutes(59);
				val.setSeconds(59);
				let new_value = parseInt(val.getTime()/-1000);
				if($('.ms-sal-limit').find('[value="'+new_value+'"]').length==0) $('.ms-sal-limit').append('<option value="'+new_value+'">'+val.toLocaleDateString()+'</option>');
				$('.ms-sal-limit').val(new_value);
				$('.ms-sal-limit-manuell').datepicker( "hide" );
			} ).hide();
			$('.ms-sal-limit-manuell').datepicker( "hide" );
			$('.ms-sal-limit').val(limit_last_value).off().on('change', function() {
				let val = $('.ms-sal-limit option').filter(':selected').val();
				$('.ms-sal-limit-manuell').datepicker( "hide" );
				$('.ms-sal-limit-manuell').hide();
				if(val == -1) {
					$('.ms-sal-limit-manuell').show();
					$('.ms-sal-limit-manuell').datepicker( "show" );
					$('#ui-datepicker-div').focus();
				} else {
					limit_last_value = val;
				}
			});
			$('.ms-sal-copy-dashboard').off().on('click', function() {
				let formdata = $('#ms-form-send-as-link').serialize();
				_copyclipboard('json/media/send-link', formdata);
			});

			// show dialog
			$('#ms-form').dialog( {
				width:		function(win_size) {
					return Math.min(getPreferedMaxDialogWidth()-40,800);
				},
				height:		function(win_size) {
					return Math.min(getPreferedMaxDialogHeight()+0,1200);
				},
				modal:		true,
				resizable:	false,
				open:		function(ev,ui) {
					if( dlg_open_callback ) dlg_open_callback();
				},
				close:		function(ev,ui) {
					$(this).dialog('destroy');
				},
			} ).show();
		});
	}


	function openMediaIDs_SendAsLightbox( media_ids, lb_title, dlg_open_callback, pluginContext ) {
		var ms_list = $('#ms-list').data('perms_ext_view',false);

		function list_callback( ms_list, j, rcpt_perms ) {
			var i;
			if( rcpt_perms===null ) ms_list.data('perms_ext_view',false); // disable extended view when no single-user rcpt_perms available
			var perms_ext_view = ms_list.data('perms_ext_view');

			$('#ms-c-list-title').html(mjt('ms-title-media'));
			ms_list.find('.hint').html(perms_ext_view?mjt('ms-hint-media-ext'):mjt('ms-hint-media-simple'));
			$('#ms-switch-perms-view',ms_list[0])
				.toggle( rcpt_perms!=null )	//_get_saved_rcpts_count() <= 1 )
				.children('span')
				.html(perms_ext_view?mjt('ms-switch-to-simple-perms-view'):mjt('ms-switch-to-ext-perms-view'))
				.off()
				.on( 'click', function() {
					ms_list.data('perms_ext_view',!ms_list.data('perms_ext_view'));
					var detached_ms_list = clear_file_list(true);
					list_callback(detached_ms_list,j,rcpt_perms);
					$('#ms-c-list').append(detached_ms_list).show();
				} );
			$('#ms-c-mail-data .hint').html(mjt('ms-hint-mail-data-media'));

			// prepare media list
			var media_classes = [];
			for( i=0; i<media_ids.length; ++i ) {
				var mid = media_ids[i];
				var media_class = j.meta && j.meta[mid] && j.meta[mid][-1] ? j.meta[mid][-1][0] : 0;
				if( arr_inArray(media_class,media_classes) == -1 ) media_classes.push(media_class);

				var filename = j.meta && j.meta[mid] && j.meta[mid][1] ? j.meta[mid][1][0] : '';
				var title = j.meta && j.meta[mid] && j.meta[mid][101] ? j.meta[mid][101][0] : '';
				title = title=='' ? ('ID '+mid) : (title+' (ID '+mid+')');

				var filesize = j.meta && j.meta[mid] && j.meta[mid][5] ? MDLocale.fmt_filesize( j.meta[mid][5][0] ) : '';
				var filename_text = htmlspecialchars(filename) + ( filesize ? ' ('+filesize+')' : '' );
				var file_node = $('#ms-template-file-item',ms_list[0]).clone(false)
					.attr({'id':'ms-file-'+mid,'media_id':mid})
					.find('.ms-item-media-id').text(title).end()
					.find('.ms-item-filename').html(filename_text).end()
					.find('.ms-item-perms').append(perms_ext_view?_get_file_item_perms_html(mid,media_class,j.download_formats,j.permissions,rcpt_perms,j.watermarks_enabled):'').end()
					.appendTo(ms_list)
					.show();

				MThumbnails.createOnTarget(
					file_node.children('.ms-item-thumb')[0],
					{
						media_id: mid,
						width: 55,
						height: 45,
						meta: j.meta[mid]||{},
						thumb_loader_anim: true,
					}
				);

				if( pluginContext ) {
					// disallow removing items when working with plugins:
					// - plugins are expect to work with an originating_lb_id
					// - = a lightbox that already exists,
					// -> plugin just hooks up to that lightbox,
					// - and changing lighboxes contents here is totally out of scope ...
					file_node.find('.ms-item-remove').hide();
				} else {
					file_node.find('.ms-item-remove').click( function(e) {
						var fnd = $(this).closest('.ms-file-item');
						var m = fnd.attr('media_id');
						fnd.remove();
						for( var x=0; x<media_ids.length; x++ ) {
							if( media_ids[x]==m ) {
								media_ids.splice(x,1);
								break;
							}
						}
						if( media_ids.length===0 ) $('#ms-form').dialog('destroy');
					} );
				}
			}

			// prepare "apply-to-all-items" permission header
			var ms_all_perms_box = $('#ms-all-perms-box',ms_list[0]).hide();
			var ms_all_perms_list = $('#ms-all-perms-list',ms_list[0]).empty();
			if( perms_ext_view ) {
				var unq_avl_perms = _get_unq_avl_perms(ms_list);
				if( unq_avl_perms.length ) {
					var _update_avl_perms_selects = function() {
						ms_all_perms_list.find('> .ms-all-perm',ms_list[0]).each( function() {
							var action = parseInt($(this).attr('id').substr(13),10),
								avl_checkboxes = ms_list.find('> .ms-file-item > .ms-item-perms > input.ms-perm:enabled[value='+action+']'),
								navailable = avl_checkboxes.length,
								nchecked = avl_checkboxes.filter(':checked').length;
							$(this)
								.children('select')
								.val( nchecked===0 ? 'no' : ( nchecked===navailable ? 'yes' : '' ) ).trigger('change.select2');
						} );
					};
					for( i=0; i<unq_avl_perms.length; ++i ) {
						var ua=unq_avl_perms[i], action=ua[0], label=ua[1];
						$('#ms-all-perms-template',ms_list[0]).clone(false)
							.attr('id','ms-all-perms-'+action)
							.children('.label').text(label).end()
							.children('select')
							.attr('name','ms-all-perms-action-'+action)
							.select2()
							.change( function() {
								var v=$(this).val(), a=parseInt($(this).closest('.ms-all-perm').attr('id').substr(13),10);
								if( v!='' ) _check_file_item_perms(ms_list,a,v=='yes');
								requestAnimationFrame(_update_avl_perms_selects);
							} )
							.end()
							.appendTo(ms_all_perms_list)
							.show();
					}
					ms_list.find('> .ms-file-item > .ms-item-perms > input.ms-perm:enabled').click( function() {
						_update_avl_perms_selects();
					} );
					_update_avl_perms_selects();
					ms_all_perms_box.show();
				}
			} else {
				ms_all_perms_box.show();
				ms_all_perms_list.html( _get_list_item_perms_html(0,media_ids,j.meta,j.download_formats,j.permissions,rcpt_perms,j.watermarks_enabled) );
			}
		} // list_callback


		if( pluginContext ) {
			MPlugins.callOnAllPluginsOfType('MediaSendView','preSetupSendViewData',true,ms_list,pluginContext);
		}


		startProgress();
		$.postJSON( 'json/media/send-info', 'media_ids='+encodeURIComponent(media_ids.join(','))+'&get_userlist=1&get_permissions=1&get_download_formats=1', function(j) {
			stopProgress();
			open_SendAsLightbox(
				j,
				media_ids,
				list_callback,
				function _lb_title_callback( j ) {
					if( typeof lb_title==='undefined' || lb_title=='' ) {
						lb_title = mjt('ms-lb-title-default')
							.replace('%1',MDLocale.fmt_date(MDTimezones.mj_date_object_to_datetime_string(new Date())))
							.replace('%2',m_sender['short-display-name']);
					}
					$('#ms_lb_title').val( lb_title );
				},
				function _extra_postdata_callback() {
					return '&media_ids='+encodeURIComponent(media_ids.join(','));
				},
				dlg_open_callback,
				pluginContext
			);
		});

	}


	function openSingleList( list_id, lb_title, callback, pluginContext ) {
		MDObject.queryObjectMediaIDs( 'lightbox', null, list_id, function( media_ids ) {
			if( callback ) callback();
			openMediaIDs( media_ids, lb_title, '', pluginContext );
		} );
	}


	function openIndexLists( lists, cur_list_id, pluginContext ) {

		if( lists.length==0 ) return;

		var candidates = [];
		var candhash = {}; // hashmap list_id=>list_info

		var i, lst;
		for( i=0; i<lists.length; ++i ) {
			lst = lists[i];
			if( lst.count>0 ) {
				candhash[lst.list_id] = lst;
				candidates.push(lst);
			}
		}
		// console.log({fn:'openIndexLists',lists,cur_list_id,candhash,candidates});

		if( candidates.length==0 ) {
			// no candidate at all
			return;
		} else if( candidates.length==1 && candhash.hasOwnProperty(cur_list_id) ) {

			// current list is the only candidate...

			let bMediaSendViewPluginsAvailable = false;
			MPlugins.iterateByType( 'MediaSendView', function(name,plugin) {
				if( !plugin.setupSendSelectView ) return;
				bMediaSendViewPluginsAvailable = true;
			} );
			if( bMediaSendViewPluginsAvailable ) {
				// there are plugins which could be attached to a lightbox ...
				// DONT skip to single-list-send!

			} else {
				// just one list candidate, no chance of plugin attachment ...
				openSingleList( cur_list_id, candhash[cur_list_id].title );
				return;
			}
		}


		var _get_list_disp_count = function(cnt) {
			return (cnt==1?mjt('n-files-1'):mjt('n-files')).replace('%1',cnt);
		};
		var check_uncheck = function() {
			var nchecked = $('#msslb-list input[type=checkbox]').filter(':checked').length;
			$('#msslb-submit').prop('disabled',!nchecked);
		};
		$('#ms-form-send-as-attachment').hide();
		$('#ms-form-send-as-lightbox').show();
		_reset_msslb();
		for( i=0; i<candidates.length; ++i ) {
			lst = candidates[i];
			var msslb_item = $('#msslb-template-item').clone(false)
				.attr({	'id': 'msslb-item-'+lst.list_id, 'list_id': lst.list_id })
				.find('input[type=checkbox]')
				.attr({	'id': 'msslb-cb-'+lst.list_id, 'value': lst.list_id })
				.click(check_uncheck)
				.end()
				.find('label')
				.attr('for','msslb-cb-'+lst.list_id)
				.find('.lb-title').text(lst.title).end()
				.find('.lb-count').text(_get_list_disp_count(lst.count)).end()
				.end()
				.find('.msslb-select-single-item')
				.click( function() {
					var list_id = $(this).closest('.msslb-item').attr('list_id');
					openSingleList( list_id, candhash[list_id].title, _reset_msslb );
				} )
				.end()
				.appendTo('#msslb-list')
				.show();


			MPlugins.iterateByType( 'MediaSendView', function(name,plugin) {
				if( !plugin.setupSendSelectView ) return;
				plugin.setupSendSelectView(
					lst,
					msslb_item.find('.msslb-select-single-item').parent(),
					function _on_click() {
						var originating_lb_id = $(this).closest('.msslb-item').attr('list_id');
						var pluginContext = {
							originating_lb_id: originating_lb_id,
							originating_lb_title: candhash[originating_lb_id].title
						};
						openSingleList( pluginContext.originating_lb_id, pluginContext.originating_lb_title, _reset_msslb, pluginContext );
					}
				);
			} );

		}

		$('#msslb-cb-'+cur_list_id).prop('checked',true);
		check_uncheck();
		$('#msslb-form form').off().submit( function() {
			// var f = $(this);
			var list_ids = [];
			$('#msslb-list input[type=checkbox]').filter(':checked').each( function() {
				list_ids.push($(this).val());
			} );
			$('#msslb-form').dialog('destroy');
			_reset_ms();
			startProgress();
			$.postJSON( 'json/media/send-info', 'list_ids='+encodeURIComponent(list_ids.join(','))+'&get_userlist=1&get_permissions=1&get_download_formats=1', function(j) {
				stopProgress();
				var all_media_ids = [];
				var resp_list_media_ids = j.list_media_ids || {};
				// pre-process lightbox items list (we may have to remove entries...)
				for( var i=0; i<list_ids.length; ) {
					var list_id = list_ids[i];
					var list_media_ids = resp_list_media_ids[list_id];
					candhash[list_id].count = list_media_ids.length; // remember actual count
					if( list_media_ids.length==0 ) list_ids.splice(i,1);
					else i++;
					all_media_ids.push(...list_media_ids);
				}

				if( list_ids.length===1 ) {

					// console.log({fn:'openIndexLists',lists,cur_list_id,candhash,candidates});
					openSingleList( cur_list_id, candhash[cur_list_id].title, _reset_msslb );

				} else if( list_ids.length>0 ) {

					open_SendAsLightbox(
						j,
						all_media_ids,
						function list_callback( ms_list, j, rcpt_perms ) {
							$('#ms-c-list-title').html(mjt('ms-title-lists'));
							ms_list.find('> .hint').html(mjt('ms-hint-lists'));
							$('#ms-switch-perms-view',ms_list[0]).hide();
							$('#ms-c-mail-data .hint').html(mjt('ms-hint-mail-data-lists'));
							// prepare lightbox items list
							var resp_list_media_ids = j.list_media_ids || {};
							for( var i=0; i<list_ids.length; ++i ) {
								var list_id = list_ids[i];
								var list_media_ids = resp_list_media_ids[list_id];
								var lst = candhash[list_id];
								// add lightbox item
								var lb_node = $('#ms-template-lb-item',ms_list[0]).clone(false)
									.attr({'id':'ms-lb-'+list_id,'list_id':list_id})
									.find('.ms-lb-item-title')
									.find('.lb-title').text(lst.title).end()
									.find('.lb-count').text(_get_list_disp_count(lst.count)).end()
									.end()
									.find('.ms-lb-item-perms').html(_get_list_item_perms_html(list_id,list_media_ids,j.meta,j.download_formats,j.permissions,rcpt_perms,j.watermarks_enabled)).end()
									.appendTo(ms_list)
									.show();
								lb_node.find('.ms-lb-item-remove').click( function(e) {
									var lbnd = $(this).closest('.ms-lb-item');
									var lid = lbnd.attr('list_id');
									lbnd.remove();
									for( var x=0; x<list_ids.length; x++ ) {
										if( list_ids[x]==lid ) {
											list_ids.splice(x,1);
											break;
										}
									}
									if( list_ids.length==0 ) $('#ms-form').dialog('destroy');
								});
								// add thumbnails of all lightbox items
								var lb_thumbs_node = lb_node.find('.ms-lb-item-thumbs');
								for( var x=0; x<list_media_ids.length; ++x ) {
									var mid = list_media_ids[x];
									var media_title = j.meta && j.meta[mid] && j.meta[mid][101] ? j.meta[mid][101][0] : '';
									var tnd = $('<div class="ms-lb-item-thumb" />')
										.attr('title',mid+': '+media_title)
										.appendTo(lb_thumbs_node);
									MThumbnails.createOnTarget(
										tnd[0],
										{
											media_id: mid,
											width: 55,
											height: 45,
											meta: j.meta[mid]||{},
											thumb_loader_anim: true,
										}
									);
								}
							}
						},
						null, // lb_title_callback
						function _extra_postdata_callback() {
							return '&list_ids='+encodeURIComponent(list_ids.join(','));
						},
						function _dlg_open_callback() {
							$('#ms-head').remove();
						},
						pluginContext
					);
				}
			});
			return false; // msslb-form form submit
		});

		// show dialog
		$('#msslb-form').dialog( {
			width:		function(win_size) {
				return Math.min(getPreferedMaxDialogWidth()-40,500);
			},
			height:		function(win_size) {
				return Math.min(getPreferedMaxDialogHeight()+0,1000);
			},
			modal:		true,
			resizable:	false,
			close:		function(ev,ui) {
				$(this).dialog('destroy');
			},
		} ).show();
	}

	return {
		openMediaIDs:	MTemplates.queryDialogHTMLWrappedFn2(['form_media_send','form_media_send_select'],openMediaIDs),
		openIndexLists: MTemplates.queryDialogHTMLWrappedFn2(['form_media_send','form_media_send_select'],openIndexLists),
	};

}(jQuery,mj); // namespace MVSend
